<template>
    <div class="card">
        <div class="card-header">
            <strong>
                <!-- BOM titel -->
                <span v-if="isCompletePackaging">
                    {{ $t("s4_title_bom_complete_packaging") }}
                </span>
                <span v-else>
                    {{ $t("s4_title_bom") }}
                </span>
            </strong>
        </div>

        <div v-if="app.currentConfiguration.BOM" class="card-body">
            <div>
                <!-- TABLE DESKTOP -->
                <table class="d-none d-lg-table" width="100%">
                    <thead>
                        <tr style="border-bottom: 1px solid #ccc">
                            <th class="text-center">{{ $t("s4_bom_ref") }}</th>
                            <th class="text-center">
                                {{ $t("s4_bom_description") }}
                            </th>
                            <th class="text-center">
                                {{ $t("s4_bom_quantity") }}
                            </th>
                            <th v-show="app.currentConfiguration.priceList.show_prices == 1" class="text-center">
                                {{ $t("s4_bom_price") }}
                            </th>
                            <th v-show="app.currentConfiguration.priceList.show_prices == 1" class="text-center">
                                {{ $t("s4_bom_subtotal") }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(product, i) in app.currentConfiguration.BOM
                                .products"
                            :key="'bom_' + product.id"
                            style="border-bottom: 1px solid #ccc"
                        >
                            <td class="text-left pr-2" style="white-space: nowrap;">{{ product.id }}</td>
                            <td class="text-left">{{ product.name }}</td>
                            <td class="text-right pl-2" style="white-space: nowrap;">
                                {{ product.quantity | currency({
                                    symbol: "",
                                    fractionCount: 0
                                })}} {{ product.unit_type }}
                            </td>
                            <td v-show="app.currentConfiguration.priceList.show_prices == 1" class="text-right pl-2" style="white-space: nowrap;">
                                {{ product.price_unit | currency }}/{{ (product.min_quantity > 1) ? product.min_quantity : "" }} {{product.unit_type}}
                            </td>
                            <td v-show="app.currentConfiguration.priceList.show_prices == 1" class="text-right pl-2" style="white-space: nowrap;">
                                {{ product.total | currency }}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <!-- TABLE MOBILE -->
                <table
                    class="d-table d-lg-none"
                    width="100%"
                    :key="bomMobileKey"
                >
                    <thead>
                        <tr style="border-bottom: 1px solid #ccc">
                            <th class="text-center td_mobile_width">
                                {{ $t("s4_bom_mobile_quantity") }}
                            </th>
                            <th v-show="app.currentConfiguration.priceList.show_prices == 1" class="text-center td_mobile_width">
                                {{ $t("s4_bom_mobile_price") }}
                            </th>
                            <th v-show="app.currentConfiguration.priceList.show_prices == 1" class="text-center td_mobile_width">
                                {{ $t("s4_bom_mobile_total") }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <bomRowMobileComponent
                            v-for="(product, i) in app.currentConfiguration.BOM
                                .products"
                            :key="i"
                            :product="product"
                        >
                        </bomRowMobileComponent>
                    </tbody>
                </table>

                <div v-show="app.currentConfiguration.priceList.show_prices == 1" class="mt-2 text-right">
                    <span class="text-center font-weight-bold mr-2">{{
                        $t("s4_Total")
                    }}</span>
                    <span>{{
                        app.currentConfiguration.BOM.total | currency
                    }}</span>
                </div>

                <!-- OBSERVATIONS -->
                <div class="mt-4 text-left"
                    v-if="app.currentConfiguration.BOM.observations !== []"> <!-- TODO: fer bé -->
                    <h3>{{ $t("s4_bom_observations_title") }}:</h3>
                    <ul>
                        <li v-for="(observation,index) in app.currentConfiguration.BOM.observations" :key="index" v-html="observation"></li>
                    </ul>
                </div>
                <div v-if="false"
                    class="mt-4 d-flex flex-row justify-content-end align-items-center"

                >
                    <div>
                        <input
                            type="checkbox"
                            id="cb_embalajesCompletos"
                            v-model="app.currentConfiguration.completePackaging"
                            @change="updateBOM"
                        />

                        <label
                            class="font-weight-bold ml-1 text-right"
                            for="cb_embalajesCompletos"
                            >{{ $t("s4_complete_packaging") }}</label
                        >

                        <i
                            v-b-tooltip.hover.html
                            :title="
                                app.translate(
                                    's4_bom_tooltip_complete_packaging'
                                )
                            "
                            id="dist_soport_info"
                            style="color:#e60000;"
                            class="ml-2 fas fa-info-circle"
                        ></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<style scoped lang="scss">
    .td_mobile_width {
        max-width: 33%;
        width: 33%;
    }
</style>

<script>
import { Fragment } from "vue-fragment";
import { app } from "../../application.js";
import bomRowMobileComponent from "./bomRowMobile.vue";

export default {
    name: "bomComponent",
    components: { Fragment, bomRowMobileComponent },
    props: {},
    data() {
        return {
            app: app,
            bomMobileKey: 1,
            showBOM: false,
        };
    },

    beforeUpdate() {
        // BUG: Fragment per permetre updates que elimin files
        this.bomMobileKey++;
    },

    computed: {
        isMobile: function (){

        },
        isCompletePackaging: function () {
            //console.log('isCompletePackaging...')
            return app.currentConfiguration.completePackaging;
        },
    },

    methods: {
        updateBOM: async function () {

            //es fa que mostri els errors de validacio
            await this.app.asyncProcess(false, true);
        },
    },
};
</script>




